<div class="wwd-advocacy">
  <div class="wwd-row">
    <div class="wwd-col">
      <div class="wwd-copy" [innerHTML]="'WHAT-WE-DO_ADVOCACY-INTRO' | translate"></div>
      <div class="wwd-list wwd-advocacy__list" [innerHTML]="'WHAT-WE-DO_ADVOCACY-LIST' | translate"></div>
    </div>

    <img
      class="wwd-media"
      src="assets/images/what-we-do/photo-advocacy.png"
      [alt]="'WHAT-WE-DO_ADVOCACY-PHOTO-ALT' | translate"
    />
  </div>
</div>
